import { CommonModule, DecimalPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from 'src/app/app.module';
import { QuickTransferModalComponent } from './quick-transfer-modal.component';


@NgModule({
    declarations: [QuickTransferModalComponent],
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateModule,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers:[DecimalPipe],
    exports: [QuickTransferModalComponent]
})
export class QuickTransferModalModule { }